import React from 'react'
import { FjCard, ContainerDiv, FjText, DefaultLink, FjTextProps, ContainerDivProps } from 'src/components/Common'
import { sharedDataStore } from 'src/store/DataStore'
import { Colors } from 'src/constants/colors'
import { ArrowRight, CheckSquare, Icon, Link, Shield } from 'react-feather'
import { Paths } from 'src/constants/navigation'
import { observer } from 'mobx-react'
import { Col, Row } from 'antd'

interface BannerProps {
  iconBackgroundColor: string
  icon: React.ReactElement
  value: number | string
  valueStyle?: FjTextProps
  secondaryValue?: number | string
  secondaryValueSuffix?: string
  subtitle: string
  clicked?: () => void
  containerStyles?: ContainerDivProps
}
export class Banner extends React.Component<BannerProps> {
  render() {
    const {
      iconBackgroundColor,
      icon,
      value,
      valueStyle,
      secondaryValue,
      secondaryValueSuffix,
      subtitle,
      clicked,
      containerStyles,
    } = this.props
    return (
      <FjCard
        cursor={clicked ? 'pointer' : undefined}
        textAlign="left"
        display="flex"
        alignItems="center"
        onClick={clicked}
        gap={24}
        {...containerStyles}
      >
        <ContainerDiv
          borderRadius="8px"
          padding="8px"
          backgroundColor={iconBackgroundColor}
          display="flex"
          alignItems="center"
        >
          {icon}
        </ContainerDiv>
        <ContainerDiv display="flex" flexDirection="column">
          <FjText fontWeight="bold500" color={Colors.tapa} fontSize="14px" textAlign="left">
            {subtitle}
          </FjText>
          <ContainerDiv display="flex" gap={8} alignItems="baseline">
            <FjText
              fontWeight="bold"
              color={value ? Colors.shark : Colors.cottonSeed}
              fontSize="22px"
              textAlign="left"
              {...valueStyle}
            >
              {value ?? '-'}
            </FjText>
            {secondaryValue ? (
              <FjText fontWeight="bold500" color={Colors.cottonSeed}>
                {secondaryValue} {secondaryValueSuffix ?? ''}
              </FjText>
            ) : null}
          </ContainerDiv>
        </ContainerDiv>
      </FjCard>
    )
  }
}

type FeedBannerCardProps = {
  leftIcon?: Icon
  rightIcon?: Icon
  text: React.ReactNode
  backgroundColor?: string
  borderColor?: string
}

export function FeedBannerCard({
  leftIcon: LeftIcon,
  rightIcon: RightIcon,
  text,
  backgroundColor = Colors.buttermilk,
  borderColor = Colors.macaroni,
}: FeedBannerCardProps) {
  return (
    <ContainerDiv
      textAlign="left"
      display="flex"
      alignItems="center"
      justifyContent="space-between"
      gap={24}
      backgroundColor={backgroundColor}
      border={`solid 1px ${borderColor}`}
      borderRadius="12px"
      padding="12px"
    >
      <ContainerDiv display="flex" alignItems="center">
        {LeftIcon && <LeftIcon size={20} style={{ marginRight: '12px' }} />}
        <FjText>{text}</FjText>
      </ContainerDiv>
      {RightIcon && <RightIcon size={20} />}
    </ContainerDiv>
  )
}

@observer
export class FeedBanner extends React.Component {
  render() {
    const { ungradedAssignmentCount, postsToReviewCount, assetsToReviewCount } = sharedDataStore.user
    const itemsToReviewCount = postsToReviewCount + assetsToReviewCount
    const totalItems = (ungradedAssignmentCount ? 1 : 0) + (itemsToReviewCount ? 1 : 0)

    if (!totalItems) return null
    return (
      <Row gutter={[16, 16]}>
        {ungradedAssignmentCount ? (
          <Col xs={24} md={Math.max(24 / totalItems, 8)}>
            <DefaultLink to={Paths.submittedAssessments}>
              <FeedBannerCard
                leftIcon={Shield}
                rightIcon={ArrowRight}
                text={
                  <>
                    You have <strong>{ungradedAssignmentCount} assessments</strong> to grade.
                  </>
                }
              />
            </DefaultLink>
          </Col>
        ) : null}
        {itemsToReviewCount ? (
          <Col xs={24} md={Math.max(24 / totalItems, 8)}>
            <DefaultLink to={Paths.contentReview}>
              <FeedBannerCard
                leftIcon={CheckSquare}
                rightIcon={ArrowRight}
                text={
                  <>
                    You have <strong>{itemsToReviewCount} items</strong> to review.
                  </>
                }
              />
            </DefaultLink>
          </Col>
        ) : null}
      </Row>
    )
  }
}

export const ActiveSharedLinkBanner = observer(() => {
  if (!sharedDataStore.user.activeSharedLinksCount) return null
  return (
    <ContainerDiv marginBottom="14px">
      <DefaultLink
        to={Paths.getDashboardPath({
          category: 'contentPerformance',
          tab: 'external',
          tableView: 'link',
          userId: sharedDataStore.user.id,
        })}
      >
        <FeedBannerCard
          leftIcon={Link}
          backgroundColor={Colors.zumthor}
          borderColor={Colors.anakiwa}
          text={
            <>
              You have <strong>{sharedDataStore.user.activeSharedLinksCount} active shared links.</strong>
            </>
          }
        />
      </DefaultLink>
    </ContainerDiv>
  )
})
